import React, { Component } from "react";
import { SearchComponent } from "../../component/SearchComponent";
import { SearchComponentWithApi } from "../../component/SearchComponentWithApi";
import { FILTER_MAPPER, isValidArray } from "../../helper";
import { Form } from "react-bootstrap";
import { get, isFunction, isNull } from "lodash";
import PropTypes from "prop-types";
import { Search } from "../reusableComponent/search";
import { filterNames } from "./filter.selector";
import { getLocalstorage } from "../../helper";
/**
 *  filterData => filtered data => it should be in array format
 *
 */

const style = {
  filterScroll: {
    maxHeight: "200px",
    overflow: "auto",
    marginTop: "10px",
    paddingTop: "10px",
    paddingBottom: "10px"
  }
};

class FilterComponent extends Component {
  isDataLoaded = false;
  state = {
    search: {},
    selectedFilters: {},
    sortedListingArr: []
  };

  componentDidMount() {
    const { filterData } = this.props;
    this.setState({
      filtersSortedData: filterData
    });
  }

  getFilteredData = (sortedListingArr, name) => {
    this.setState(prevState => {
      return {
        sortedListingArr: {
          ...prevState.sortedListingArr,
          [name]: sortedListingArr
        },
        isSearching: get(sortedListingArr, "isSearching")
      };
    });
  };

  handleCheckbox = (filter, filterName) => {
    const { onChange } = this.props;
    filter.checked = !filter.checked;
    isFunction(onChange) && onChange(filter, filterName);
    localStorage.setItem("ClearAll", JSON.stringify(false));
  };

  getFilterBySearch = (search, filterName) => {
    const { onChange } = this.props;
    isFunction(onChange) && onChange(search.searchedText, filterName);
  };

  getSearchedFilters = (filterList = [], searchText = "") => {
    return filterList.filter(item => {
      if (searchText === "") return true;
      else {
        const regex = new RegExp(searchText, "ig");
        return regex.test(item.displayName);
      }
    });
  };

  searchDocument = (e, filterName) => {
    this.setState({
      [filterNames[filterName]]: e.target.value.trim()
    });
  };

  getStateFilterVal = _filterName => {
    const {
      projectSponsoringMinistry,
      projectSector,
      recipientMinistryState,
      recipientState,
      issueSponsoringMinistry,
      recipientMinistry,
      recipientStateDepartment,
      guests,
      createdBy,
      projectProponent,
      proponent,
      milestone,
      sponsoringDepartment,
      projectTags,
      projectStatus,
      projectLocation,
      centerState,
      districtProjectLocation
    } = this.state;
    switch (_filterName) {
      case "projectSponsoringMinistry":
        return projectSponsoringMinistry;
      case "projectSector":
        return projectSector;
      case "recipientMinistryState":
        return recipientMinistryState;
      case "recipientState":
        return recipientState;
      case "issueSponsoringMinistry":
        return issueSponsoringMinistry;
      case "recipientMinistry":
        return recipientMinistry;
      case "recipientStateDepartment":
        return recipientStateDepartment;
      case "guests":
        return guests;
      case "createdBy":
        return createdBy;
      case "projectProponent":
        return projectProponent;
      case "proponent":
        return proponent;
      case "milestone":
        return milestone;
      case "sponsoringDepartment":
        return sponsoringDepartment;
      case "projectTags":
        return projectTags;
      case "projectStatus":
        return projectStatus;
      case "projectLocation":
        return projectLocation;
      case "centerState":
        return centerState;
      case "districtProjectLocation":
        return districtProjectLocation;
      default:
        return "";
    }
  };

  placeCheckedFiltersOnTop(filterValues) {
    let sortedFilterValues = [];

    for (let i = 0; i < filterValues.length; i++) {
      if (filterValues[i].checked === false) {
        sortedFilterValues.push(filterValues[i]);
      } else {
        sortedFilterValues.unshift(filterValues[i]);
      }
    }
    return sortedFilterValues;
  }

  render() {
    const { filterData, clearAll, filtersValue, projectCategory } = this.props;
    let filtersKeysArr = Object.keys(filterData || {});
    if (
      projectCategory != "CENTRAL" &&
      window.location.pathname == "/issue-list"
    ) {
      const index = filtersKeysArr.indexOf("escalationLevel");
      if (index !== -1) {
        filtersKeysArr.splice(index, 1);
      }
    } else {
      filtersKeysArr = Object.keys(filterData || {});
    }

    const index = filtersKeysArr.indexOf("escalationLevel");
    if (index > -1 && index != null && index != undefined) {
      filtersKeysArr.splice(index, 1);
      filtersKeysArr.splice(2, 0, "escalationLevel");
    }

    // const minLengthForSearch = 5;
    if (!filtersKeysArr.length) {
      return null;
    }
    const user = getLocalstorage("user");
    // if (
    //   get(user, "groupCategory") == "STATE" ||
    //   get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ||
    //   get(user, "groupCategory") == "CENTRAL"
    // ) {
    //   filterData.agendaStages = {};
    // }
    return (
      isValidArray(filtersKeysArr) && (
        <React.Fragment>
          {isValidArray(filtersKeysArr)
            ? filtersKeysArr.map(filterName => {
                const currentFilter = filterData[filterName];
                if (currentFilter && currentFilter.values) {
                  currentFilter.values = this.placeCheckedFiltersOnTop(
                    currentFilter.values
                  );
                }
                const filterCurrentValue = filtersValue[filterName];
                const _filterName =
                  filterNames[get(currentFilter, "displayName")];
                let searchedFilterList = this.getSearchedFilters(
                  get(currentFilter, "values"),
                  this.getStateFilterVal(_filterName)
                );

                // const searchResult = sortedListingArr[filterName];
                if (!isValidArray(get(currentFilter, "values"))) {
                  return null;
                }
                return (
                  <Form.Group
                    data-cy="filter-category-container"
                    className="search-filters"
                    key={filterName}
                    style={{
                      display:
                        projectCategory == "STATE" &&
                        get(currentFilter, "displayName", "NA") ==
                          "Issue Location"
                          ? "none"
                          : null
                    }}
                  >
                    <Form.Label
                      data-test={get(
                        currentFilter,
                        "displayName",
                        "NA"
                      ).replace(" ", "-")}
                    >
                      {get(currentFilter, "displayName", "NA")}
                    </Form.Label>
                    {get(currentFilter, "searchable") ? (
                      <SearchComponentWithApi
                        keyName="search"
                        value={filterCurrentValue}
                        onChange={value => {
                          this.getFilterBySearch(value, filterName);
                        }}
                      />
                    ) : null}
                    {isValidArray(get(currentFilter, "values")) &&
                    get(currentFilter, "values").length > 10 ? (
                      <Search
                        placeholder="Search"
                        keyName="searchText"
                        onChange={e =>
                          this.searchDocument(e, currentFilter.displayName)
                        }
                      />
                    ) : null}
                    <div style={style.filterScroll}>
                      {JSON.parse(localStorage.getItem("ClearAll")) == true ? (
                        <>
                          {searchedFilterList.forEach(
                            item => (item.checked = false)
                          )}
                        </>
                      ) : (
                        <> </>
                      )}
                      {isValidArray(searchedFilterList)
                        ? searchedFilterList.map((filter, index) => {
                            // if (get(filter, "key") === "NO_IMPLEMENTATION") {
                            //   return null;
                            // }
                            if (
                              get(filter, "displayName") ===
                              "NO_COMPLETION_STAGE"
                            ) {
                              return null;
                            }
                            clearAll && (filter.checked = false);
                            if (isNull(get(filter, "displayName"))) {
                              return null;
                            }
                            return (
                              <Form.Check
                                className={`form-checkbox ${
                                  get(filter, "checked") ? "checked" : ""
                                }${
                                  get(filter, "count") ||
                                  filterName === "projectGroupBy"
                                    ? ""
                                    : "checkbox-disabled"
                                }`}
                                key={
                                  get(currentFilter, "displayName") ==
                                  "Project District"
                                    ? null
                                    : `stage-${get(filter, "key")}`
                                }
                              >
                                <Form.Check.Input
                                  type="checkbox"
                                  name="ministry-issues"
                                />
                                <Form.Check.Label
                                  name={
                                    get(currentFilter, "displayName") ==
                                    "Project District"
                                      ? null
                                      : `stage-${get(filter, "key")}`
                                  }
                                  onClick={e => {
                                    e.stopPropagation();
                                    this.handleCheckbox(filter, filterName);
                                  }}
                                >
                                  <span
                                    style={{
                                      width:
                                        get(filter, "displayName").length >=
                                          29 && filterName == "escalationLevel"
                                          ? null
                                          : filterName == "escalationLevel"
                                          ? "auto"
                                          : get(filter, "displayName").length <=
                                              20 ==
                                              true &&
                                            get(filter, "displayName") !=
                                              "PHYSICALLY_COMPLETED"
                                          ? "auto"
                                          : null
                                    }}
                                    data-test={get(
                                      filter,
                                      "displayName"
                                    ).replace(" ", "-")}
                                  >
                                    {get(filter, "displayName") ==
                                    "PHYSICALLY_COMPLETED" ? (
                                      <>PHYSICALLY COMPLETED/CC UNDER ISSUE</>
                                    ) : (
                                      <>{get(filter, "displayName")}</>
                                    )}
                                    {get(filter, "count") &&
                                    get(filter, "count") >= 0
                                      ? `(${get(filter, "count")})`
                                      : ""}
                                  </span>
                                </Form.Check.Label>
                              </Form.Check>
                            );
                          })
                        : null}
                    </div>
                  </Form.Group>
                );
              })
            : null}
        </React.Fragment>
      )
    );
  }
}

FilterComponent.propTypes = {
  filterData: PropTypes.array,
  callApiOnSuccess: PropTypes.func
};

FilterComponent.defaultProps = {
  filterData: [],
  callApiOnSuccess: () => {}
};

export default FilterComponent;
